import CalendarPicker from "@/components/CalendarPicker";
import { endOfDay } from "date-fns";
import { useTranslation } from "react-i18next";

type DatesFilterProps = {
    label: string;
    startDate?: Date;
    setStartDate: (startDate: Date | undefined) => void;
    endDate?: Date;
    setEndDate: (endDate: Date | undefined) => void;
};

const DatesFilter = ({
    label,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
}: DatesFilterProps) => {
    const { t } = useTranslation();

    return (
        <div>
            <p>{label}</p>
            <div className="flex flex-wrap gap-2 rounded-md bg-white p-3">
                <CalendarPicker
                    date={startDate}
                    label={t(
                        "customViewDialog.viewConfig.dates.startDateLabel",
                    )}
                    placeholder={t(
                        "customViewDialog.viewConfig.dates.startDatePlaceholder",
                    )}
                    setDate={setStartDate}
                />
                <CalendarPicker
                    date={endDate}
                    label={t("customViewDialog.viewConfig.dates.endDateLabel")}
                    placeholder={t(
                        "customViewDialog.viewConfig.dates.endDatePlaceholder",
                    )}
                    setDate={(date) =>
                        setEndDate(date ? endOfDay(date) : undefined)
                    }
                />
            </div>
        </div>
    );
};

export default DatesFilter;
